import firebase from 'firebase'
import 'firebase/firestore'

var config = {
  apiKey: 'AIzaSyAkxawpcnbF16fPArazjNl-vErsxhbdB6g',
  authDomain: 'laphsmyn-republic.firebaseapp.com',
  databaseURL: 'https://laphsmyn-republic.firebaseio.com',
  projectId: 'laphsmyn-republic',
  storageBucket: 'laphsmyn-republic.appspot.com',
  messagingSenderId: '829314465715'
}

const firebaseApp = firebase.initializeApp(config)
export default firebaseApp.firestore({
  timestampsInSnapshots: true
})



// WEBPACK FOOTER //
// ./src/firestore.js